module.exports = __webpack_public_path__ + "img/img_app_search.842461ad.png";